import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Save as SaveIcon,
  Cancel as CancelIcon,
  ArrowForwardIos as AddIcon,
  DeleteOutline as DelIcon,
  Search as SearchIcon,
} from "@material-ui/icons";

import {
  Grid,
  Button,
  InputAdornment,
  Typography,
  Box,
} from "@material-ui/core";
import * as types from "src/store/types/produtos";

import {
  salvarProdutoCompl,
  pesquisarProdutosCompl,
  excluirProdutoCompl,
  pesquisarComplementos,
  inserirProdutoCompl,
  atualizarProdutoCompl,
} from "src/store/actions/produtos";
import {
  DataGrid,
  InputDebounce,
  InputMask,
  Loading,
  Modal,
} from "src/components";
import NumberFormat from "react-number-format";

function GestaoComplementos({ modal, modals }) {
  const dispatch = useDispatch();
  const {
    loading,
    produto,
    produto_complementos,
    complemento_lista,
    controlar_estoque,
  } = useSelector((state) => state.produtos);
  const [titulo, setTitulo] = useState("");

  const pesquisar = () => {
    dispatch([
      pesquisarComplementos({
        titulo: titulo,
        page: 1,
        per_page: 100,
      }),
      pesquisarProdutosCompl({ produto_id: produto.id, titulo }),
    ]);

    console.log();
  };

  useEffect(() => {
    if (modal.complemento) {
      pesquisar();
    } else {
      dispatch([
        { type: types.LOAD_COMPLEMENTOS, payload: [] },
        { type: types.SET_PAGE_COMPLEMENTO, payload: 1 },
        { type: types.SET_TOTAL_COMPLEMENTO, payload: 0 },
        { type: types.SET_PERPAGE_COMPLEMENTO, payload: 10 },
        { type: types.LOADING_COMPLEMENTO, payload: false },
      ]);
    }
  }, [produto.id, modal.complemento, titulo]);

  const incluirComplemento = async (complemento) => {
    dispatch({ type: "LOADING_DELIV_PRODUTO", payload: true });
    await inserirProdutoCompl({
      complemento_id: complemento.id,
      valor: complemento.valor_atual,
      produto_id: produto.id,
    });
    pesquisar();
  };

  const excluirComplemento = async (rowData) => {
    dispatch({ type: "LOADING_DELIV_PRODUTO", payload: true });
    await excluirProdutoCompl(rowData.id);
    pesquisar();
  };

  return (
    <Modal open={modal.complemento}>
      <Loading loading={loading} />
      <Grid style={{ maxWidth: "1200px" }} container spacing={1}>
        <Grid item sm={12}>
          <Typography> Adicionar complementos </Typography>
        </Grid>
        <Grid item sm={12}>
          <InputDebounce
            value={titulo}
            onChange={(value) => setTitulo(value)}
            placeholder="Titulo do Complemento"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid container item spacing={1} sm={12}>
          <Grid item sm={5}>
            <DataGrid
              columns={[
                {
                  title: "Titulo",
                  field: "titulo",
                  width: "auto",
                  cellStyle: { whiteSpace: "nowrap" },
                },
                {
                  title: "Preço",
                  render: (rowData) => (
                    <NumberFormat
                      prefix="R$ "
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      fixedDecimalScale={true}
                      value={rowData.valor_atual || 0}
                      decimalScale={2}
                    />
                  ),
                  // width: ,
                  headerStyle: { padding: 0 },
                  cellStyle: { padding: 0 },
                },
              ]}
              data={complemento_lista}
              options={{
                maxBodyHeight: 410,
                minBodyHeight: 410,
              }}
              actions={[
                {
                  icon: () => <AddIcon color="primary" />,
                  tooltip: "Adicionar",
                  onClick: (event, rowData) => incluirComplemento(rowData),
                },
              ]}
            />
          </Grid>
          <Grid item sm={7}>
            {!controlar_estoque ? (
              <DataGrid
                columns={[
                  {
                    title: "Titulo",
                    field: "titulo",
                    cellStyle: { whiteSpace: "nowrap" },
                  },
                  {
                    title: "Preço (R$)",
                    field: "valor",
                  },
                ]}
                data={produto_complementos}
                options={{
                  maxBodyHeight: 410,
                  minBodyHeight: 410,
                }}
                actions={[
                  {
                    icon: () => <DelIcon color="primary" />,
                    tooltip: "Remover",
                    onClick: (event, rowData) => excluirComplemento(rowData),
                  },
                ]}
              />
            ) : (
              <DataGrid
                columns={[
                  {
                    title: "Titulo",
                    field: "titulo",
                    headerStyle: { paddingLeft: 10 },
                    cellStyle: { paddingLeft: 10, whiteSpace: "nowrap" },
                    editable: "never",
                  },
                  {
                    title: "Estoque",
                    field: "quantidade_estoque",
                    width: 30,
                    headerStyle: { padding: 0 },
                  },
                  {
                    title: "Mínimo",
                    field: "quantidade_estoque_min",
                    width: 30,
                    headerStyle: { padding: 0 },
                  },
                  {
                    title: "Máximo",
                    field: "quantidade_estoque_max",
                    width: 30,
                    headerStyle: { padding: 0 },
                  },
                  {
                    title: "Preço",
                    field: "valor",
                    render: (rowData) => (
                      <NumberFormat
                        prefix="R$ "
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        fixedDecimalScale={true}
                        value={rowData.valor || 0}
                        decimalScale={2}
                      />
                    ),
                    editComponent: (tableData) => (
                      <InputMask
                        type="cash"
                        value={tableData.rowData.valor}
                        onChange={(e) =>
                          tableData.onChange(e.target.values.floatValue)
                        }
                      />
                    ),
                    headerStyle: { whiteSpace: "nowrap" },
                  },
                ]}
                data={produto_complementos}
                options={{
                  maxBodyHeight: 410,
                  minBodyHeight: 410,
                  rowStyle: {
                    padding: 0,
                    textAlign: "center",
                  },
                }}
                editable={{
                  onRowUpdate: async (newData, oldData) => {
                    await atualizarProdutoCompl(newData);
                    pesquisar();
                  },
                }}
                actions={[
                  {
                    icon: () => <DelIcon color="primary" />,
                    tooltip: "Remover",
                    onClick: (event, rowData) => excluirComplemento(rowData),
                  },
                ]}
              />
            )}
          </Grid>
        </Grid>
        <Box width="100%" display="flex" justifyContent="flex-end">
          <Button
            color="secondary"
            size="small"
            onClick={() => modals({ ...modals, complemento: false })}
          >
            {<CancelIcon />}&nbsp;Fechar
          </Button>
        </Box>
      </Grid>
    </Modal>
  );
}

export default GestaoComplementos;
